import ActionButton from "../common/ActionButton";
import CategoryBadge from "../common/CategoryBadge";
import type { Article } from "../../types/article";

type Props = {
    article: Article;
};

export default function FeaturedNewsHero({ article }: Props) {
    return (
        <section className="overflow-hidden rounded-2xl border border-white/10 bg-[#0d121b] shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
            <div className="grid lg:grid-cols-[1.15fr_0.85fr]">
                <div className="relative min-h-[320px] lg:min-h-[520px]">
                    <img
                        src={article.image}
                        alt={article.title}
                        className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#06080d] via-[#06080d]/20 to-transparent" />
                </div>

                <div className="flex flex-col justify-center gap-5 p-6 md:p-8 lg:p-10">
                    <CategoryBadge label={article.category} />

                    <div>
                        <p className="mb-3 text-xs font-bold uppercase tracking-[0.18em] text-white/45">
                            Publié le {article.publishedAt}
                        </p>

                        <h1 className="text-3xl font-black uppercase leading-tight text-white md:text-5xl">
                            {article.title}
                        </h1>
                    </div>

                    <p className="max-w-2xl text-base leading-7 text-white/75 md:text-lg">
                        {article.excerpt}
                    </p>

                    <div className="flex flex-wrap gap-3">
                        <ActionButton label="Lire l’actualité" />
                        <button className="rounded-md border border-white/15 px-5 py-3 text-sm font-black uppercase tracking-wide text-white transition hover:border-[#e5ff00]/40 hover:text-[#e5ff00]">
                            Voir l’affiche
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}